<template>
    <div>
        <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
        <div id="security" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-user-shield mr-1"></i> Security Questions
                        </h5>
                    </div>
                    <div class="modal-body">
                        <h5><b>Further secure your account by adding Security Questions</b></h5>
                        <div class="alert alert-success2" role="alert">
                            Security questions add an extra layer of protection to your account by verifying your identity and authorizing critical functions, such as recovering a forgotten email or mobile number. Limit your answers in 1 to 3 words.
                        </div>
                        <div class="row" v-for="(selected, index) in selectedQuestions" :key="index">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Security Question {{ index + 1 }}</label>
                                    <select v-model="selectedQuestions[index]" class="form-control custom-select-sm"
                                        :class="{ 'is-invalid': $v.selectedQuestions[index].$error }">
                                        <option value="" selected disabled>- Select -</option>
                                        <option v-for="question in availableQuestions(index)" :key="question.id"
                                            :value="question">
                                            {{ question.description }}
                                        </option>
                                    </select>
                                    <span v-if="selectedQuestions[index]" class="fs-14"><i>{{ findTagalog(selectedQuestions[index]) }}</i></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Answer</label>
                                    <input v-model="answers[index]" type="text"
                                        class="form-control form-control-sm text-uppercase"
                                        :class="{ 'is-invalid': $v.answers[index].$error }" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary px-3" @click="submitForm">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div id="recheck" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-user-edit mr-1"></i> Complete Your Profile
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-primary2" role="alert">
                            Please update your profile to continue using your account.
                        </div>

                        <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                            <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                            <a target="#err0" hidden id="err"></a>
                            <div class="alert-body">
                                <p v-if="error_message && errors.length == 0" class="mb-0">
                                    {{ error_message }}
                                </p>
                                <div v-for="(v, k) in errors" :key="k">
                                    <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="!check.cs_code">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Civil Status</label><span class="text-danger">*</span>
                                    <v-select label="cs_desc" :options="civil_status" :reduce="cs_desc => cs_desc.cs_code" :class="{'vs-invalid': $v.borrower.cs_code.$error}"
                                        :clearable="false" v-model="borrower.cs_code" placeholder="- Select -" @input="selectedCS(borrower.cs_code)" />
                                </div>
                            </div>
                        </div>

                        <div v-if="married">
                            <hr />
                            <label>Name of Spouse</label>
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>First Name</label><span class="text-danger">*</span>
                                        <input class="form-control form-control-sm text-uppercase" v-model="spouse.fname" :class="{'is-invalid': $v.spouse.fname.$error}" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="form-group mb-0">
                                        <label>Middle Name</label><span class="text-danger">*</span>
                                        <input class="form-control form-control-sm text-uppercase" v-model="spouse.mname" :disabled="cb2"
                                            :class="{ 'is-invalid': $v.spouse.mname.$error }" />
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input id="cb2" class="custom-control-input" type="checkbox" v-model="cb2" @change="spouse.mname=''" />
                                            <label for="cb2" class="custom-control-label">Click here if no middle name</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>Last Name</label><span class="text-danger">*</span>
                                        <input class="form-control form-control-sm text-uppercase" v-model="spouse.lname" :class="{'is-invalid': $v.spouse.lname.$error}" />
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="form-group">
                                        <label>Suffix</label>
                                        <select class="form-control custom-select-sm" v-model="spouse.suffix_code">
                                            <option :value='null'>- Select -</option>
                                            <option v-for="(item,index) in suffixes" :key="index" :value="item.suffix_code">{{item.suffix_desc}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-8 col-sm-6">
                                    <div class="form-group">
                                        <label>Birth Date of Spouse</label><span class="text-danger">*</span>
                                        <input-calendar v-model="spouse.date_birth" class="form-control form-control-sm" :class="{'is-invalid': $v.spouse.date_birth.$error}"
                                            id="spouse-bdate" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" />
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div class="row">
                            <div class="col-md-6" v-if="!check.number_child">
                                <div class="form-group">
                                    <label>No. of Children</label><span class="text-danger">*</span>
                                    <input type="number" class="form-control form-control-sm" v-model="borrower.number_child" :class="{'is-invalid': $v.borrower.number_child.$error}" />
                                </div>
                            </div>
                            <div class="col-md-6" v-if="!check.number_fam">
                                <div class="form-group">
                                    <label>Household Size</label><span class="text-danger">*</span>
                                    <input type="number" class="form-control form-control-sm" v-model="borrower.number_fam" :class="{'is-invalid': $v.borrower.number_fam.$error}" />
                                </div>
                            </div>
                        </div>
                        <div v-if="!check.add_ship">
                            <hr />
                            <p><b>Tell us where you are currently residing</b></p>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Province<span class="text-danger">*</span></label>
                                        <v-select label="province" :options="provinces" :class="{'vs-invalid': $v.address.province_code.$error}"
                                            :reduce="province => province.province_code" placeholder="- Select -" :clearable="false" v-model="address.province_code" @input="getCity(address.province_code)" />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>City/Municipality<span class="text-danger">*</span></label>
                                        <v-select label="city" :options="cities" :reduce="city => city.city_code" :class="{'vs-invalid': $v.address.city_code.$error}"
                                            placeholder="- Select -" :clearable="false" v-model="address.city_code" @input="getBarangay(address.city_code)" />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Barangay<span class="text-danger">*</span></label>
                                        <v-select label="bname" :options="barangays" :reduce="bname => bname.bcode" :class="{'vs-invalid': $v.address.bcode.$error}"
                                            placeholder="- Select -" :clearable="false" v-model="address.bcode" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>House No/Block & Lot/ Building<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="address.bldg" :class="{'is-invalid': $v.address.bldg.$error}" />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Street Name/Subdivision<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="address.street_address" :class="{'is-invalid': $v.address.street_address.$error}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Home Address Ownership<span class="text-danger">*</span></label>
                                        <select class="form-control custom-select-sm" v-model="address.add_ship" :class="{'is-invalid': $v.address.add_ship.$error}">
                                            <option selected disabled :value='null'>- Select -</option>
                                            <option v-for="(item,index) in ownership" :key="index" :value="item.owner_code">{{item.owner_desc}}</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6" v-if="!check.len_loc">
                                    <div class="form-group">
                                        <label>Length of Stay in Location (Years)<span class="text-danger">*</span></label>
                                        <input type="number" class="form-control form-control-sm" v-model="address.len_loc" :class="{'is-invalid': $v.address.len_loc.$error}" />
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary px-3" @click="submitProfile">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        required,
        requiredIf
    } from "vuelidate/lib/validators";
    import {
        apiRefCity,
        apiRefBrgy,
        apiRefProvince,
        apiRefOwnership
    } from "@js/api/getReferences";
    export default {
        components: {},
        data() {
            return {
                loader: 0,
                questions: [],
                selectedQuestions: ["", "", ""], // Store selected questions
                answers: ["", "", ""], // Store the answers
                borrower: '',
                address: '',
                spouse: {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    date_birth: null
                },
                suffixes: [],
                civil_status: [],
                provinces: [],
                cities: [],
                barangays: [],
                ownership: [],
                cb2: false,
                married: false,

                form: {},
                check: {},
                error: 0,
                error_message: '',
                errors: [],
            };
        },
        validations() {
            const married = this.married;
            const cb2 = this.cb2;
            return {
                selectedQuestions: {
                    0: {
                        required
                    },
                    1: {
                        required
                    },
                    2: {
                        required
                    }
                },
                answers: {
                    0: {
                        required
                    },
                    1: {
                        required
                    },
                    2: {
                        required
                    }
                },

                //profile
                spouse: {
                    fname: {
                        required: requiredIf(() => married)
                    },
                    lname: {
                        required: requiredIf(() => married)
                    },
                    mname: {
                        required: requiredIf(() => married && !cb2)
                    },
                    date_birth: {
                        required: requiredIf(() => married)
                    },
                },
                borrower: {
                    cs_code: {
                        required
                    },
                    number_child: {
                        required
                    },
                    number_fam: {
                        required
                    },
                },
                address: {
                    // len_loc: {
                    //     required
                    // },
                    add_ship: {
                        required
                    },
                    bcode: {
                        required
                    },
                    street_address: {
                        required
                    },
                    bldg: {
                        required
                    },
                    city_code: {
                        required
                    },
                    province_code: {
                        required
                    },
                }
            };
        },
        computed: {
            processingAPI() {
                return this.loader > 0;
            },
        },
        methods: {
            onError(err) {
                this.error = 1;
                if (err.response.status == 500) {
                    this.error_message = 'Transaction Failed';
                } else {
                    if (err.response && err.response.data) {
                        this.errors = err.response.data.errors || [];
                        this.error_message = err.response.data.message;
                    } else {
                        this.error_message = err.message
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            },
            apiProfileUpdate() {
                this.loader++;
                const payload = {
                    borrower: this.borrower,
                    address: this.address,
                    spouse: this.spouse
                };

                axios
                    .post("/api/recheck-profile-update", payload)
                    .then(res => {
                        this.loader--;
                        $("#recheck").modal("hide");
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Your profile has been successfully updated.',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        }).then((result) => {

                        });
                    })
                    .catch(err => {
                        this.loader--;
                        this.onError(err);
                    });
            },
            submitProfile() {
                this.$v.spouse.$touch();
                this.$v.borrower.$touch();
                this.$v.address.$touch();
                if (this.$v.spouse.$invalid || this.$v.borrower.$invalid || this.$v.address.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.onError(err);
                } else {
                    this.error = 0;
                    this.apiProfileUpdate();
                }
            },
            async apiRefAddress() {
                this.loader++;
                try {
                    this.provinces = await apiRefProvince();
                    this.ownership = await apiRefOwnership();
                    this.cities = await apiRefCity(this.address.province_code);
                    this.barangays = await apiRefBrgy(this.address.city_code);
                    this.loader--;
                } catch (err) {
                    this.loader--;
                }
            },

            getRefCivilStatus() {
                this.loader++;
                axios
                    .get("/api/ref-civil-status")
                    .then(res => {
                        this.civil_status = res.data
                        this.loader--;
                    })
                    .catch(err => {
                        this.loader--;
                    });
            },
            getRefSuffix() {
                this.loader++;
                axios
                    .get("/api/ref-suffix")
                    .then(res => {
                        this.suffixes = res.data
                        this.loader--;
                    })
                    .catch(err => {
                        this.loader--;
                    });
            },
            selectedCS(val) {
                if (val != 'CS002') {
                    this.married = false;
                    this.spouse = {
                        fname: null,
                        mname: null,
                        lname: null,
                        suffix_code: null,
                        date_birth: null
                    }
                } else {
                    this.married = true;
                }
            },
            findTagalog(selectedQuestion) {
                const question = this.questions.find(q => q.id === selectedQuestion.id);
                return question ? question.tagalog : '';
            },
            apiCheckProfile() {
                this.loader++;
                axios.get("/api/recheck-profile")
                    .then(res => {

                        const bor = res.data.borrower;
                        const add = res.data.address;
                        const spouse = res.data.spouse;

                        this.borrower = bor;
                        this.address = add;

                        const arr = [bor.cs_code, bor.number_fam, bor.number_child, add.add_ship];
                        const hit = arr.some(x => x === null || x === '');

                        this.check = {
                            cs_code: bor.cs_code,
                            number_fam: bor.number_fam,
                            number_child: bor.number_child,
                            add_ship: add.add_ship,
                        };
                        if (!add.add_ship) {
                            this.apiRefAddress();
                        }
                        if (!bor.cs_code) {
                            this.getRefCivilStatus();
                            this.getRefSuffix();
                        }
                        if (hit) {
                            $("#recheck").modal("show");
                        }

                        if (spouse) {
                            this.spouse = spouse
                            this.spouse.date_birth = this.spouse.date_birth ? moment(this.spouse.date_birth).format('YYYY-MM-DD') : '';
                        }
                        this.loader--;
                    })
                    .catch(err => {
                        this.loader--;
                    });
            },
            apiGetSQ() {
                this.loader++;
                axios.get("/api/get-security-questions")
                    .then(res => {
                        this.questions = res.data.questions;
                        this.loader--;

                        if (!res.data.security) {
                            $("#security").modal("show");
                        } else {
                            this.apiCheckProfile();
                        }
                    })
                    .catch(err => {
                        this.loader--;
                    });
            },

            availableQuestions(index) {
                const selectedIds = this.selectedQuestions.map(q => q && q.id);
                return this.questions.filter(q => !selectedIds.includes(q.id) || (this.selectedQuestions[index] && this.selectedQuestions[index].id === q.id));
            },

            apiSubmit(form) {
                this.loader++;
                axios.post("/api/post-security-questions", {
                        security: form
                    })
                    .then(res => {
                        this.loader--;
                        const msg = res.data.message
                        $("#security").modal("hide");
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: msg,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        });
                        this.apiCheckProfile();
                    })
                    .catch(err => {
                        this.loader--;
                    });
            },
            submitForm() {
                this.$v.selectedQuestions.$touch(); // Trigger validation for the entire form
                this.$v.answers.$touch();
                if (this.$v.answers.$invalid || this.$v.selectedQuestions.$invalid) {
                    return;
                }
                const form = this.selectedQuestions.map((question, index) => {
                    return {
                        sq_id: question.id,
                        answer: this.answers[index]
                    };
                });
                this.apiSubmit(form)
            }
        },
        created() {
            this.apiGetSQ();
        },
        mounted() {

        }
    };
</script>
<style scoped>
    .alert-primary2 {
        color: #004085;
        background-color: #cce5ff;
        border-color: #b8daff;
    }

    .alert-success2 {
        color: #155724;
        background-color: #d4edda;
        border-color: #c3e6cb;
    }
</style>